export const priceFormat = (price, currency = 'USD') =>
  price ? (String(currency).toUpperCase() === 'USD' ? `$${price}` : `${price} ${currency}`) : __('sm@_get');



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/utils/index.js